var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center my-1"},[_c('i',{class:(_vm.icon + " fit-icon " + _vm.iconColor)}),_c('span',{staticClass:"pl-3 font-medium text-14px text-oLightGray"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }